import React from 'react';
export const Hero = () => {
  return <div className="bg-gradient-to-b from-red-100 to-gray-100 py-12 md:py-20 relative overflow-hidden" data-id="element-53">
      {/* Subtle background elements */}
      <div className="absolute top-0 right-0 w-full h-32 bg-red-200 opacity-30" data-id="element-54"></div>
      <div className="absolute top-32 right-0 w-full h-32 bg-white opacity-40" data-id="element-55"></div>
      <div className="absolute top-64 right-0 w-full h-32 bg-red-200 opacity-30" data-id="element-56"></div>
      {/* Stars element */}
      <div className="absolute top-4 left-4 md:top-8 md:left-8" data-id="element-57">
        <div className="flex space-x-2" data-id="element-58">
          {[...Array(5)].map((_, i) => <svg key={i} className="w-6 h-6 text-red-700 opacity-50" fill="currentColor" viewBox="0 0 24 24" data-id="element-59">
              <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" data-id="element-60" />
            </svg>)}
        </div>
      </div>
      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-61">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-62">
          <div className="md:w-1/2" data-id="element-63">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4" data-id="element-64">
              When Schools Become Targets
            </h1>
            <h2 className="text-xl md:text-2xl text-red-700 font-medium mb-6" data-id="element-65">
              Inside America's Alarming Rise in School and Campus Shootings —
              And What No One Is Talking About
            </h2>
            <p className="text-lg md:text-xl font-semibold text-gray-700 mb-6" data-id="element-66">
              Some books tell stories. This one delivers a wake-up call.
            </p>
            <div className="mt-8 flex justify-center md:justify-start" data-id="element-67">
              <a href="#offer" className="inline-block bg-red-700 hover:bg-red-800 text-white font-bold py-3 px-8 rounded-lg text-lg transition-colors duration-300 border-2 border-red-700 shadow-lg" data-id="element-68">
                Get My Copy Now – Only $19.97
              </a>
            </div>
          </div>
          <div className="md:w-1/2 relative" data-id="element-69">
            <div className="absolute inset-0 rounded-md bg-red-700 shadow-lg transform -rotate-12" data-id="element-70"></div>
            {/* Book Cover with Badge */}
            <div className="relative" data-id="element-71">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2whgTYZMbwofmuGsw7zcdq/ChatGPT_Image_Sep_21%2C_2025%2C_02_50_29_AM.png" alt="When Schools Become Targets Book Cover" className="w-full max-w-md mx-auto shadow-2xl rounded-md relative z-10" data-id="element-72" />
              {/* "Now Available Online" Badge - Smaller size */}
              <div className="absolute -top-3 -right-3 md:-top-4 md:-right-4 w-16 h-16 md:w-20 md:h-20 z-20" data-id="element-73">
                <div className="relative w-full h-full" data-id="element-74">
                  <div className="absolute inset-0 rounded-full bg-red-600 shadow-lg transform -rotate-12 scale-90 sm:scale-100" data-id="element-75"></div>
                  <div className="absolute inset-1 rounded-full bg-gray-800 flex items-center justify-center" data-id="element-76">
                    <div className="text-center" data-id="element-77">
                      <p className="text-white text-[8px] md:text-[10px] font-bold" data-id="element-78">
                        NOW
                      </p>
                      <p className="text-white text-[8px] md:text-[10px] font-bold" data-id="element-79">
                        AVAILABLE
                      </p>
                      <p className="text-white text-[8px] md:text-[10px] font-bold" data-id="element-80">
                        ONLINE
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};